import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  IconTypes,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { PencilButtonComponent } from '../pencil-button/pencil-button.component';
@Component({
  selector: 'app-filter-view-header',
  templateUrl: './filter-view-header.component.html',
  styleUrls: ['./filter-view-header.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, PencilButtonComponent, PencilIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterViewHeaderComponent {
  @Input() showFilterIcon = true;
  @Input() showCloseButton = true;
  @Input() showResetButton: boolean = false;
  @Output() resetFilterFn = new EventEmitter<void>();
  @Output() closePanel = new EventEmitter<void>();

  onReset() {
    this.resetFilterFn.emit();
  }

  onCloseClicked() {
    this.closePanel.emit();
  }

  protected IconTypes = IconTypes;
}
